import axios from 'axios'

export default class {
  /**
   * @param {String} token OAuth 2.0 token
   */
  constructor (token) {
    if (!token) {
      throw new Error('token cannot be null')
    }

    this.loading = false

    this.client = axios.create({
      baseURL: 'https://photoslibrary.googleapis.com/v1',
      headers: { 'Authorization': `Bearer ${token}` }
    })

    this.client.interceptors.request.use(config => {
      this.loading = true
      return config
    }, error => {
      this.loading = false
      return Promise.reject(error)
    })

    this.client.interceptors.response.use(response => {
      this.loading = false
      return response
    }, error => {
      this.loading = false
      return Promise.reject(error)
    })
  }

  async listAlbum () {
    const response = await this.client.get('/albums')

    if (response.data && response.data.albums) {
      return response.data.albums
    } else {
      return []
    }
  }

  async listAlbumContent (albumId) {
    const response = await this.client.post('/mediaItems:search', {
      pageSize: 30,
      albumId
    })

    if (response.data && response.data.mediaItems) {
      return response.data.mediaItems
    } else {
      return []
    }
  }
}
